// 库存管理
export default [
  {
    path: "/inventory",
    name: 'inventory',
    meta: { title: "库存管理" },
    component: () => import("../views/inventory/index.vue"),
    children: [
      {
        path: "/inventory/storeList",
        meta: { title: "门店库存列表", isMenu: true },
        component: () => import("../views/inventory/storeList.vue"),
      },
    ],
  },
]
